type UrlBreadcrumb = {
  metadata: Record<string, unknown>;
};

type UrlEvent = {
  request: { url?: string };
};

// The browser SDK records the current URL before our login bootstrap removes
// ?jwt=. Keep paths for diagnosis, but strip URL suffixes from telemetry fields.
function pathWithoutQueryOrFragment(url: string): string {
  const firstSuffix = url.search(/[?#]/);
  return firstSuffix === -1 ? url : url.slice(0, firstSuffix);
}

export function redactBugsnagBreadcrumbUrls(breadcrumb: UrlBreadcrumb): void {
  for (const key of ['from', 'to', 'url']) {
    const value = breadcrumb.metadata[key];
    if (typeof value === 'string') {
      breadcrumb.metadata[key] = pathWithoutQueryOrFragment(value);
    }
  }
}

export function redactBugsnagRequestUrl(event: UrlEvent): void {
  if (typeof event.request?.url === 'string') {
    event.request.url = pathWithoutQueryOrFragment(event.request.url);
  }
}

export function redactBugsnagNetworkRequest<T extends { url: string | null }>(request: T): T {
  return typeof request.url === 'string'
    ? { ...request, url: pathWithoutQueryOrFragment(request.url) }
    : request;
}
